import styled from "styled-components";
import {
  LOGO_HOME,
  IMG_APPBAR_BG,
} from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
		rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  z-index: 1000;
  background-image: url(${IMG_APPBAR_BG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const LogoWrapper = styled.div`
flex: 1;
align-items: center;
justify-content: center;
`;

export const Logo = styled(LOGO_HOME)`
max-width: 62px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
`;

export const IconsWrapper = styled.div`
display: flex;
gap: 8px;
align-items: center;
justify-content: center;

svg {
  cursor: pointer;
}

@media screen and (max-width: 320px) {
gap: 6px;

  svg {
    width: 20px;
  }
}
`;

export const Icon = styled.div`
display: flex;
gap: 4px;
align-items: center;
justify-content: center;
padding: 4px 8px;
border-radius: 21px;
background: rgba(0, 0, 0, 0.20);
cursor: pointer;

@media screen and (max-width: 320px) {
  padding: 3px 6px;
}
`;

export const Text = styled.div`
color: #FFF;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
`;